import React from 'react'
import { useHistory } from 'react-router-dom'
import { Box } from 'components/Layout'
import { DEVICE } from 'theme'
import { useIsMinDevice } from 'utils/hooks/useMedia'
import { useToaster } from 'utils/useToaster'
import { ResetPasswordCard } from 'sharedComponents/ResetPasswordCard'

const ResetPassword: React.VFC = () => {
  const isMobile = !useIsMinDevice(DEVICE.TABLET)
  const history = useHistory()
  const { setToastMessage } = useToaster()

  return (
    <Box
      height="100vh"
      display="flex"
      justifyContent="center"
      alignItems={!isMobile ? 'center' : undefined}
    >
      <ResetPasswordCard
        title="Reset password"
        newPasswordLabel="New password"
        newPasswordPlaceholder="Enter new password"
        newPasswordConfirmationLabel="Password confirmation"
        newPasswordConfirmationPlaceholder="Enter password again"
        resetPasswordButtonLabel="Reset password"
        signInButtonLabel="Sign in"
        onSignInButtonClick={() => history.push('/')}
        onSuccess={() => {
          history.push('/')
          setToastMessage('Password successfully changed', 'success')
        }}
      />
    </Box>
  )
}

export { ResetPassword }
